export const rupiah = (v) => {
  const n = Number(v) || 0;
  return "Rp " + n.toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

export const num = (v, d = 0) => {
  const n = Number(v) || 0;
  return n.toLocaleString("id-ID", { maximumFractionDigits: d });
};

export const pct = (v) => `${(Number(v) || 0).toFixed(2)}%`;

export const co2 = (v) => `${num(v, 1)} kg`;
